import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { SvgIcon } from "../SvgIcon";
export var Filter = function Filter(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.401 14.304a.767.767 0 01-.232.664.797.797 0 01-1.128 0L5.833 11.76a.791.791 0 01-.232-.664V7L1.769 2.096a.8.8 0 01.136-1.12A.834.834 0 012.401.8h11.2c.176 0 .344.064.496.176a.8.8 0 01.136 1.12L10.401 7v7.304zM4 2.4l3.168 4.048v4.416l1.6 1.6V6.44l3.168-4.04H4z",
    fill: "currentColor"
  }));
};
export default Filter;